import { FC, useMemo, useState } from 'react';
import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { Button, Form, FormItem, Input } from '$uikit';
import { useRoute, useRouter } from 'react-router5';
import { format, parse } from '$utils';
import { NOTIFY } from '$shared/constants/pages';
import { mainActions } from '$store/main';
import { useDispatch } from 'react-redux';
import { notifyActions } from '$store/notify';
import { useTranslator } from '$hooks';

export const NotifyDateSelector: FC = () => {
  const t = useTranslator();
  const { route } = useRoute();
  const router = useRouter();
  const dispatch = useDispatch();

  const curFrom = parseInt(route.params.from || '0', 10);
  const curTo = parseInt(route.params.to || '0', 10);

  const isDateSelected = curFrom > 0 || curTo > 0;

  const [from, setFrom] = useState(curFrom * 1000);
  const [to, setTo] = useState(curTo * 1000);

  const fromString = useMemo(() => {
    if (from > 0) {
      return format(from, 'yyyy-MM-dd');
    }

    return '';
  }, [from]);

  const toString = useMemo(() => {
    if (to > 0) {
      return format(to, 'yyyy-MM-dd');
    }

    return '';
  }, [to]);

  const handleApply = () => {
    const newParams = { ...route.params };
    if (from > 0) {
      newParams.from = Math.floor(from / 1000);
    } else {
      delete newParams.from;
    }

    if (to > 0) {
      newParams.to = Math.floor(to / 1000) + 86399;
    } else {
      delete newParams.to;
    }
    router.navigate(NOTIFY, newParams, { replace: true });
    dispatch(mainActions.setPopup(null));
    dispatch(notifyActions.load());
  };

  const handleClear = () => {
    const newParams = { ...route.params };
    delete newParams.from;
    delete newParams.to;
    router.navigate(NOTIFY, newParams, { replace: true });
    dispatch(mainActions.setPopup(null));
    dispatch(notifyActions.load());
  };

  return (
    <BottomSheet title={t('notify_date_selector_title')}>
      <Form>
        <FormItem title={t('notify_date_selector_from')}>
          <Input
            type="date"
            value={fromString}
            onChange={(e) => {
              setFrom(
                Math.floor(parse(e.target.value, 'yyyy-MM-dd', new Date()).getTime()),
              );
            }}
          />
        </FormItem>
        <FormItem title={t('notify_date_selector_to')}>
          <Input
            type="date"
            value={toString}
            onChange={(e) => {
              console.log(e.target.value);
              setTo(
                Math.floor(parse(e.target.value, 'yyyy-MM-dd', new Date()).getTime()),
              );
            }}
          />
        </FormItem>
        <FormItem>
          <Button onClick={handleApply}>{t('notify_date_selector_apply')}</Button>
        </FormItem>
        {isDateSelected && (
          <FormItem>
            <Button mode="secondary" onClick={handleClear}>
              {t('notify_date_selector_clear')}
            </Button>
          </FormItem>
        )}
      </Form>
    </BottomSheet>
  );
};
